import * as React from "react";

import { Modal, ListGroup, ListGroupItem } from "react-bootstrap";

type Props = {
    queryDebugInfo: {
        [x: string]: unknown;
    };
};

type State = {
    showDialog: boolean;
};

export class SearchQueryDebugInfo extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            showDialog: false
        };
    }

    _showDialog = () => {
        this.setState({ showDialog: true });
        return false;
    };

    _hideDialog = () => {
        this.setState({ showDialog: false });
        return false;
    };

    _renderDialog(): React.ReactNode {
        const preStyle = { whiteSpace: "pre-wrap" as const, maxHeight: "6em", overflowY: "auto" as const };
        return (
            <Modal show onHide={this._hideDialog}>
                <Modal.Header closeButton>
                    <Modal.Title>Query details</Modal.Title>
                </Modal.Header>
                <Modal.Body className="container-fluid">
                    <ListGroup
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore -- FIXME check if this does anything
                        variant="flush">
                        {Object.keys(this.props.queryDebugInfo).map((key) => {
                            const data = this.props.queryDebugInfo[key];
                            if (!data) {
                                return null;
                            } else if (data instanceof Array) {
                                return (
                                    <ListGroupItem key={key}>
                                        {key}:
                                        {data.map((entry, i) => (
                                            <pre key={i} style={preStyle}>
                                                {entry}
                                            </pre>
                                        ))}
                                    </ListGroupItem>
                                );
                            } else {
                                return (
                                    <ListGroupItem key={key}>
                                        {key}:
                                        <pre style={preStyle}>
                                            {typeof data === "string" ? data : JSON.stringify(data, null, " ")}
                                        </pre>
                                    </ListGroupItem>
                                );
                            }
                        })}
                    </ListGroup>
                </Modal.Body>
            </Modal>
        );
    }

    render() {
        return (
            <span>
                <a style={{ fontSize: "70%" }} onClick={this._showDialog} className="test-search-query-debug-show">
                    (debug info)
                </a>
                {this.state.showDialog && this._renderDialog()}
            </span>
        );
    }
}
